import type { RouteLocation } from 'vue-router';
import { withAuthRedirect } from '../runtime/utils/authRedirect';

export default defineNuxtPlugin({
    name: 'guard',
    dependsOn: ['auth', 'sitemap', 'alerts', 'i18n'],
    async setup(nuxtApp)
    {
        const { $router, $sitemap, $alert, $i18n } = useNuxtApp();
        const store = useAuthStore();
        const options = useAuthOptions();

        // Pierwsza nawigacja przechodzi przez kontrole bez względu na nazwy tras. Trasa przekierowująca
        // kończy wejście na trasie docelowej, zanim strażnik zostanie podłączony, więc obie strony
        // pierwszej nawigacji mają tę samą nazwę. Przy kolejnych nawigacjach porównanie nazw zostaje,
        // żeby zmiana samego zapytania na tej samej trasie nie powtarzała kontroli
        let firstNavigation = true;

        $router.beforeEach(async (to: RouteLocation, from: RouteLocation, next: any) =>
        {
            const first = firstNavigation;

            firstNavigation = false;

            if (to.meta && 'auth' in to.meta && (first || to.name != from?.name))
            {
                const auth: any = to.meta.auth;

                // Wymuszenie zmiany hasła
                if (auth !== false && store.authenticated === true && store.identity.forcePasswordChange === true && to.meta.stop !== true)
                {
                    $alert.debounceInfo($i18n.$t('[[[Twoje hasło wygasło. Zmień je na nowe.]]]'));
                    next(options.routes.changePassword);

                    return;
                }

                if (auth !== false && store.authenticated === true && localStorage.getItem('authenticator-setup-required') === 'true' && to.meta.stop !== true)
                {
                    $alert.debounceInfo($i18n.$t('[[[Skonfiguruj aplikację uwierzytelniającą, aby kontynuować.]]]'));
                    next(withAuthRedirect({ path: '/account/two-factor', query: { setup: 'required' } }, to.fullPath));

                    return;
                }

                if (typeof (auth) === 'boolean')
                {
                    if (auth === true && store.authenticated === false)
                    {
                        next(withAuthRedirect(options.routes.loginPage, to.fullPath));

                        return;
                    }

                    if (auth === false && store.authenticated === true)
                    {
                        next(options.routes.homePage);

                        return;
                    }

                    if (store.authenticated === true)
                    {
                        // Pobranie aktualnego widoku z sitemapa
                        const node = await $sitemap.find(to);

                        // Sprawdzenie uprawnień do widoku w sitemapie
                        if (node && node.allowed == false)
                        {
                            next(options.routes.forbidden);

                            return;
                        }
                    }
                }

                if (Array.isArray(auth) && auth.length > 0)
                {
                    if (store.authenticated === false)
                    {
                        next(withAuthRedirect(options.routes.loginPage, to.fullPath));

                        return;
                    }
                }
            }

            next();
        });
    }
});
